module.exports = __webpack_public_path__ + "images/_/programs/zeroHeroes/images/characters/ian_side-73146e2c2ff78c910e4856232244643f.png";


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/images/characters/ian_side.png
// module id = 2496
// module chunks = 2